import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import {
  Breadcrumb,
  Button,
  Card,
  Container,
  Row,
  Col,
  Form,
  Dropdown,
  InputGroup
} from "react-bootstrap";
import {
  CustomPaging,
  EditingState,
  PagingState,
  SortingState,
  SearchState,
  FilteringState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableEditColumn,
  SearchPanel,
  Toolbar,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-bootstrap4';

import { Loading } from 'components/Loading/loading';
import { useLocalStorage } from 'react-use';
import Popup from './Popup.js';
import PopupEditing from 'components/ReactTable/PopupEditing.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import { setYear } from 'date-fns';

const SORT_FIELD_MAP = {
  auditee: `auditee.SCOPE_ID`,
  instrument: `instrument.INSTRUMENT_NAME`,
};

function Index() {

  const history = useHistory();

  const [listYear, setListYear] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [tempSearch, setTempSearch] = useState('');
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [pageSizes] = useState([50]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [sorting, setSorting] = useState([{ columnName: 'SCHEDULE_ID', direction: 'desc' }]);
  const [columns] = useState([
    { name: 'action', title: 'Action', getCellValue: (row) => row.SCHEDULE_STATUS !== 'DRAFT'
      ?
      // <Button onClick={() => history.push(`/admin/audits/${row.SCHEDULE_ID}`)} variant="info" size="sm">Detail</Button>
      // <Button onClick={() => window.open(`/admin/audits/${row.SCHEDULE_ID}`, "_blank", 'noopener,noreferrer,resizable')} variant="info" size="sm">Detail</Button>
      <Link to={`/admin/audits/${row.SCHEDULE_ID}`}>
        <Button variant="info" size="sm">Detail</Button>
      </Link>
      : ``
    },
    { name: 'SCHEDULE_ID', title: 'ID' },
    { name: 'auditee', title: 'Auditee', getCellValue: row => row?.auditee?.department?.DEPT_NAME ?? `n-a` },
    { name: 'START_DATE', title: 'Year', getCellValue: row => moment(row?.START_DATE).format('YYYY') ?? `n-a`  },
    {
      name: 'instrument', title: 'Instrument',
      getCellValue: row => (row?.instrument?.standard)
      ? `${row.instrument.standard.STANDARD_NAME} - ${row.instrument.INSTRUMENT_NAME}`
      : `n-a`
    },
    { name: 'SCHEDULE_STATUS', title: 'Status' },
    { name: 'scope', title: 'Scope', getCellValue: row => row?.auditee?.SCOPE_ID ?? `n-a` }
  ]);

  const [defaultColumnWidths] = useState([
    { columnName: 'SCHEDULE_ID', width: 75 },
    { columnName: 'auditee', width: 340 },
    { columnName: 'START_DATE', width: 100 },
    {columnName: 'instrument', width: 300 },
    {columnName: 'SCHEDULE_STATUS', width: 100 },
    {columnName: 'action', width: 100 },
    { columnName: 'scope', width: 50 },
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);

  const [tableColumnExtensions] = useState([
    { columnName: 'auditee', wordWrapEnabled: true },
    { columnName: 'instrument', wordWrapEnabled: true },
  ]);

  const [defaultFilters] = useState([{ columnName: 'scope', value: 1 },]);
  const [filteringStateColumnExtensions] = useState([
    { columnName: 'scope', filteringEnabled: false },
    { columnName: 'action', filteringEnabled: false },
  ]);
  const [years, setYears] = useState('');
  const [scope, setScopes] = useState('');

  const getRowId = row => row.SCHEDULE_ID;

  // const statuses = ['All', 'Not Started', 'In Progress', 'Need Assistance', 'Deferred', 'Completed'];

  const commitChanges = async ({ added, deleted }) => {

    try {

      if (added) {
        const newItem = {...added.pop()};
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}schedules`, newItem, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
          params: {
            expand: `instrument.standard,auditee.department,score`,
            sort: `-SCHEDULE_ID`,
          }
        });

        setRows([
          {
            ...response.data,
            SCHEDULE_STATUS: 'DRAFT'
          },
          ...rows
        ]);

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Create Success`,
            message: `New audit schedule successfully created.`,
          }
        });

      }

      if (deleted) {
        const item = rows.find(row => row.SCHEDULE_ID === [...deleted].pop());
        console.log(item)
        const onSuccessCallback = async () => {
          const response = await axios.delete(`${process.env.REACT_APP_API_HOST}schedules/${item.SCHEDULE_ID}`, {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          });
          setRows([...rows].filter(row => row.SCHEDULE_ID !== item.SCHEDULE_ID))
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Are you sure?`,
            message: `You are about to delete "${item?.auditee?.department?.DEPT_NAME} - ${item?.instrument?.standard?.STANDARD_NAME} - ${item?.instrument?.INSTRUMENT_NAME}" schedule.`,
            onSuccess: {
              title: `Success`,
              message: `Delete Success`,
              callback: onSuccessCallback,
            }
          }
        });
      }

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
     }
  };

  const [filter, setFilter] = useState([]);

  const onFilterChange = (filters) => {
    setFilter(filters);
  };

  const fetchSchedules = async () => {

    setLoading(true);

    try {
      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedules`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: `auditee.department,instrument.standard`,
          page: currentPage + 1,
          'per-page': pageSize,
          'search': searchValue,
          'year': years,
          'scope': scope,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`,
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);
      setLoading(false);

    } catch (error) {
      setLoading(false);
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchListYear = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedule/list-year`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        }
      });
      setListYear(response.data.result)

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setSearchValue(event.target.value);
    }
  };



  useEffect(fetchSchedules, [searchValue, pageSize, currentPage, sorting]);

  useEffect(fetchListYear, []);

  useEffect(() => {

    if (editingRowIds && editingRowIds.length > 0) {
      return history.push(`/admin/schedules/${editingRowIds.pop()}/edit`);
    }

  }, [editingRowIds]);

  return (
    <Container fluid>
      {swal}
      <Breadcrumb>
        <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
          Schedules
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Index
        </Breadcrumb.Item>
      </Breadcrumb>
      {swal}
      <Row>
        <Col md="12">
          <Card>
            <Card.Header>
              <Card.Title as="h4">Audit Schedule List</Card.Title>
                <Card.Body>
                <Row>
                  Additional Filtering
                </Row>
                <Row>
                  <Form.Group as={Col}>
                    <Form.Control className="w-100" name="YEAR_ID" as="select" onChange=
                      {e => {
                        setYears(e.target.value);
                      }}
                    >
                      <option>Select Years...</option>
                      {listYear && listYear.map((year, key) => (
                        <option key={key} value={year.VALUE?year.VALUE:''}>
                          {year.YEAR}
                        </option>
                        ))}
                      {/* <option value='2021'>2021</option>
                      <option value='2022'>2022</option>
                      <option value='2023'>2023</option>
                      <option value='2024'>2024</option>
                      <option value='2025'>2025</option>
                      <option value=''>All</option> */}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Control className="w-100" name="SCOPE_ID" as="select" onChange=
                      {e => {
                        setScopes(e.target.value);
                      }}
                    >
                      <option>Select Scope...</option>
                      <option value='1'>Program Studi</option>
                      <option value='2'>Fakultas</option>
                      <option value='3'>Department</option>
                      <option value='5'>Univ</option>
                      <option value=''>All</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Button onClick={fetchSchedules}>Show</Button>
                  </Form.Group>
                </Row>
                </Card.Body>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md="4"></Col>
                <Col md="4"></Col>
                <Col md="4">
                <Form.Group>
                <InputGroup style={{ width: 250 }}>
                  <Form.Control
                    type="text"
                    placeholder="Search...."
                    onChange={(event) => setTempSearch(event.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <InputGroup.Text>
                    <i className="nc-icon nc-zoom-split"
                      style={{
                        cursor: "pointer",
                        transition: "color 0.3s ease, transform 0.2s ease"
                      }}
                      onClick={() => setSearchValue(tempSearch)}
                      onMouseOver={(e) => (e.target.style.color = "blue")}
                      onMouseOut={(e) => (e.target.style.color = "")}>
                    </i>
                  </InputGroup.Text>
                </InputGroup>
                </Form.Group>
                </Col>
              </Row>
              <Grid
                rows={rows}
                columns={columns}
                getRowId={getRowId}
              >

                {/* <SearchState onValueChange={setSearchValue}/> */}
                <PagingState
                  currentPage={currentPage}
                  onCurrentPageChange={setCurrentPage}
                  pageSize={pageSize}
                  onPageSizeChange={setPageSize}
                />

                <SortingState
                  sorting={sorting}
                  onSortingChange={setSorting}
                />

                <CustomPaging totalCount={totalCount} />
                <EditingState
                  editingRowIds={editingRowIds}
                  onEditingRowIdsChange={setEditingRowIds}
                  onCommitChanges={commitChanges}
                />
                <FilteringState
                  onFiltersChange={onFilterChange}
                  columnExtensions={filteringStateColumnExtensions}
                />
                <IntegratedFiltering />
                <Table columnExtensions={tableColumnExtensions}/>
                <TableColumnResizing
                  columnWidths={columnWidths}
                  onColumnWidthsChange={setColumnWidths}
                />
                <TableHeaderRow showSortingControls />
                {/* <TableFilterRow /> */}
                <TableEditColumn
                  showAddCommand
                  showEditCommand
                  showDeleteCommand
                  // commandComponent={CommandComponent}
                />
                <PagingPanel pageSizes={pageSizes} />
                <PopupEditing popupComponent={Popup} />
                <Toolbar />
                {/* <SearchPanel /> */}
                {loading && <Loading />}
              </Grid>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Index;